import env from "app/utils/env";

export const IS_DEFAULT_SIGNIN = false;

export const PRODUCT_EXPIRATION_DAY_LIMIT = 30;

export const getProfileApiUrl = () => {
	return `${env("USER_AUTH_API_URL")}`;
};

export const ONGOING_MARKETING_OPERATION = {
	ULTRA_LUXE: "ul",
	FREE_HOTEL: "fh",
};

export const FIRST_MERCHANDISING_POSITION = 0;
export const SECOND_MERCHANDISING_POSITION = 3;
export const THIRD_MERCHANDISING_POSITION = 7;
export const FOURTH_MERCHANDISING_POSITION = 11;

export const OAUTH_PARAMS = {};
